import { capitalCase } from "change-case";

import type { MediaAssetValue } from "../controls/index.ts";

type TitleOptions = {
  namedId?: string;
  mediaAsset: MediaAssetValue;
};

export const getMediaAssetTitle = ({ namedId, mediaAsset }: TitleOptions) => {
  if (!namedId) {
    if (mediaAsset.source === "url") return mediaAsset.url.split("/").pop() ?? "";

    const index = mediaAsset.name.lastIndexOf(".");
    return capitalCase(index > 0 ? mediaAsset.name.substring(0, index) : mediaAsset.name);
  }

  return namedId;
};

type CategoryOptions = TitleOptions & {
  category?: string;
};

export const getCategory = (values: CategoryOptions) =>
  `${values.category ? `${values.category} : ` : ""}${getMediaAssetTitle(values)}`;
